<template>
  <a-row :gutter="16">
    <a-col :xxl="4" :xl="6" :lg="8" :md="12">
      <a-range-picker v-model:value="queryForm.daterange" :locale="locale" value-format="YYYY-MM-DD"
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;">
      </a-select>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-input v-model:value="queryForm.number" placeholder="合同编号" style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="getData">查询</a-button>
    </a-col>
  </a-row>
  <div class="d-flex justify-space-between align-center mb-2 mt-2">
    <a-space>
      <a-button type="primary" @click="add"> 新增合同 </a-button>
      <a-button type="link" @click="getData"> 刷新数据 </a-button>
    </a-space>
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{
      current: page,
      pageSize: limit,
      total: count,
      showQuickJumper: true,
      showSizeChanger: true,
    }" @change="(pagination) => {
      page = pagination.current;
      limit = pagination.pageSize;
    }" row-key="_id" :row-selection="{
      selectedRowKeys,
      onChange: (keys) => selectedRowKeys = keys
    }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'verify_time'">
        {{ verify_time ? $filters.dateFormat(record.verify_time) : '-' }}
      </template>
      <template v-if="column.dataIndex === 'remoteurl'">
        <a href="javascript:;"> {{ record.originalname }} </a>
        <a-space>
          <a-upload v-if="record.verify_state !== 1" :before-upload="(file) => beforeUpload(file, record._id)"
            :disabled="uploading" :showUploadList="false" accept=".doc,.docx,.pdf">
            <a href="javascript:;" class="underline text-warning"> 上传 </a>
          </a-upload>
          <a v-if="record.remoteurl" href="javascript:;" class="underline"> 查看 </a>
          <a v-if="record.remoteurl" href="javascript:;" class="underline"> 下载 </a>
        </a-space>
      </template>
      <template v-if="column.dataIndex === 'sign_time'">
        {{ sign_time ? $filters.dateFormat(record.sign_time) : '-' }}
      </template>
      <template v-if="column.dataIndex === 'state'">
        <template v-if="record.remoteurl">
          <template v-if="record.verify_state === 0">
            <a-tag color="processing">待审核</a-tag>
            <a-space>
              <a-popconfirm placement="left" title="合同信息无误，审核通过？" @confirm="pass(record._id)">
                <a href="javascript:;" class="underline text-success"> 通过 </a>
              </a-popconfirm>
              <a-popconfirm placement="left" title="合同信息有误，审核驳回？" @confirm="reject(record._id)">
                <a href="javascript:;" class="underline text-error"> 驳回 </a>
              </a-popconfirm>
            </a-space>
          </template>
          <a-tag v-if="record.verify_state === 1" color="success">审核通过</a-tag>
          <a-tag v-if="record.verify_state === -1" color="error">审核驳回</a-tag>
        </template>
        <a-tag v-else color="warning">待上传</a-tag>
      </template>
      <template v-if="column.dataIndex === 'operation'">
        <a-space>
          <a v-if="record.verify_state !== 1" href="javascript:;" class="underline text-blue" @click="edit(record)">
            编辑
          </a>
          <a-popconfirm v-if="record.verify_state !== 1" placement="left" title="删除合同？" @confirm="remove(record._id)">
            <a href="javascript:;" class="underline text-error"> 删除 </a>
          </a-popconfirm>
        </a-space>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="contractModal" :title="contractModalTitle" @ok="save" @cancel="cancelSave" ok-text="确认"
    cancel-text="取消" :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false"
    :closable="!saving" width="500px">
    <a-form ref="formRef" name="contractForm" :model="contractForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
      autocomplete="off">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="合同编号" name="number" :rules="[{ required: true, message: '请输入合同编号' }]">
            <a-input v-model:value="contractForm.number" placeholder="合同编号" :disabled="saving">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="商户" name="orgid" :rules="[{ required: true, message: '请选择商户' }]">
            <a-select v-model:value="contractForm.orgid" :options="sorgs" :filter-option="$filters.filterOption"
              show-search placeholder="请选择">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="生效开始时间" name="valid_start" :rules="[{ required: true, message: '请选择开始时间' }]">
            <a-date-picker v-model:value="contractForm.valid_start" :locale="locale" value-format="YYYY-MM-DD"
              style="width:100%;" />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item label="生效结束时间" name="valid_end" :rules="[{ required: true, message: '请选择结束时间' }]">
            <a-date-picker v-model:value="contractForm.valid_end" :locale="locale" value-format="YYYY-MM-DD"
              style="width:100%;" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script setup>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";
const columns = [
  { title: '合同编号', dataIndex: 'number', width: 150 },
  { title: '商户', dataIndex: 'org', width: 150 },
  { title: '开始时间', dataIndex: 'valid_start', width: 120 },
  { title: '结束时间', dataIndex: 'valid_end', width: 120 },
  { title: '审核时间', dataIndex: 'verify_time', width: 150, },
  { title: '合同文件', dataIndex: 'remoteurl', width: 150, },
  { title: '签约时间', dataIndex: 'sign_time', width: 150, },
  { title: '状态', dataIndex: 'state', width: 100, },
  { title: '操作', dataIndex: 'operation', width: 150, },
];
const { proxy } = getCurrentInstance();
const formRef = ref();

const queryForm = ref({
  daterange: ["", ""],
  orgid: "ALL",
  number: "",
});
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const selectedRowKeys = ref([]);
const contractForm = ref({});
const contractModal = ref(false);
const contractModalTitle = ref('');
const saving = ref(false);
const orgs = ref([]);
const uploading = ref(false);

const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  getData();
});

const getData = () => {
  dataLoading.value = true;
  proxy.$api.doAPI("/contract/list", { page: page.value, limit: limit.value, ...queryForm.value, type: "2" }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = _.map(res.data.list, n => {
        return {
          ...n,
          valid_start: proxy.$dateFormat(n.valid_start, 'YYYY-MM-DD'),
          valid_end: proxy.$dateFormat(n.valid_end, 'YYYY-MM-DD'),
          create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm:ss'),
        };
      });
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const initForm = () => {
  return {
    _id: "", number: "", orgid: null, valid_start: "", valid_end: "",
  };
};
const add = () => {
  contractForm.value = initForm();
  contractModalTitle.value = '新增合同';
  contractModal.value = true;
};
const edit = (item) => {
  contractForm.value = _.pick(item, _.keys(initForm()));
  contractModalTitle.value = '编辑合同';
  contractModal.value = true;
}
const save = async () => {
  try {
    await formRef.value.validateFields();
    saving.value = true;
    proxy.$api.doAPI("/contract/save", { dataForm: contractForm.value, type: "2" }).then((res) => {
      saving.value = false;
      if (res.code === 0) {
        contractModal.value = false;
        getData();
      } else {
        message.error(res.msg);
      }
    }).catch((err) => {
      saving.value = false;
      console.error(err);
    });
  } catch (errorInfo) {
    console.log("Failed:", errorInfo);
  }
};
const cancelSave = () => { };
const beforeUpload = (file, _id) => {
  console.log('beforeUpload');
  let checkresult = checkfile(file);
  if (checkresult.code != 0) return message.error(checkresult.msg);
  doUpload(file, _id);
};
const checkfile = (file) => {
  const valid_size = file.size / 1024 / 1024 < 10;
  if (!valid_size) {
    return { code: 1, msg: "文件不能超过10MB" };
  }
  return { code: 0 };
}
const doUpload = async (file, _id) => {
  uploading.value = true;
  const slicefiles = proxy.$utils.sliceFile(file.size);
  const faid = proxy.$utils.uuid();
  for (let i = 0; i < slicefiles.length; i++) {
    let slicefile = slicefiles[i];
    const formData = new FormData();
    if (slicefile.chunks > 1) {
      let _file = file.slice(slicefile.from, slicefile.to);
      formData.set("file", _file);
    } else {
      formData.set("file", file);
    }
    formData.set("faid", faid);
    formData.set("chunk", slicefile.chunk);
    formData.set("chunks", slicefile.chunks);
    formData.set("originalname", file.name);
    formData.set("contractid", _id);
    try {
      let res = await proxy.$api.doUpload("/contract/plupload", formData);
      if (res.code === 0) {
      } else {
        message.error(res.msg);
        break;
      }
    } catch (e) {
      console.error(e);
      message.error(e.message);
      break;
    }
  }
  console.log('doUpload-finished');
  uploading.value = false;
  getData();
}
const pass = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/contract/pass", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const reject = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/contract/reject", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const sign = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/contract/sign", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const remove = (_id) => {
  dataLoading.value = true;
  proxy.$api.doAPI("/contract/remove", { _id }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      getData();
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
}
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>